export function addressAutocompleteFieldValidation() {
	const elementAddressAutocompleteInputs = document.querySelectorAll(".js-address-autocomplete");

	if (elementAddressAutocompleteInputs) {
		elementAddressAutocompleteInputs.forEach(elementAddressAutocompleteInput => {
			const dataAutocomplete = elementAddressAutocompleteInput.getAttribute('data-autocomplete'),
				hiddenFields = document.querySelectorAll('[data-autocomplete="' + dataAutocomplete + '"]');

			if (hiddenFields.length > 0) {
				const elementInputText = elementAddressAutocompleteInput.closest('.js-solar-lead-field');

				let validationMessage = '',
					valid = true;

				if (elementAddressAutocompleteInput.hasAttribute('required') && (elementAddressAutocompleteInput.value === '' ||
					elementAddressAutocompleteInput.value === undefined ||
					elementAddressAutocompleteInput.value === null)) {

					valid = false;
					validationMessage += elementAddressAutocompleteInput.dataset.validation;

				}

				if (elementAddressAutocompleteInput.hasAttribute('required')) {
					hiddenFields.forEach(hiddenField => {
						const hiddenFieldValue = hiddenField.value;

						if (hiddenFieldValue === '' || hiddenFieldValue === undefined || hiddenFieldValue === null) {

							validationMessage += ' ' + hiddenField.dataset.validation;
							valid = false;

						}
					});
				}

				if (valid) {
					elementAddressAutocompleteInput.setCustomValidity('');
					elementInputText.classList.remove('is-invalid')
					elementAddressAutocompleteInput.classList.remove('is-invalid')
				} else {
					elementAddressAutocompleteInput.closest('.c-input').querySelector('.js-input-field-hint').innerText = validationMessage.trim();
					elementAddressAutocompleteInput.setCustomValidity(validationMessage);
					elementInputText.classList.add('is-invalid')
					elementAddressAutocompleteInput.classList.add('is-invalid')
				}

			}
		});

	}

}

export function setHiddenFieldValues(place = '', addressAutocompleteInputField) {
	const dataAutocomplete = addressAutocompleteInputField.getAttribute('data-autocomplete'),
		elementStreetHiddenField = document.querySelector('.js-autocomplete-street[data-autocomplete="' + dataAutocomplete + '"]'),
		elementStreetNumberHiddenField = document.querySelector('.js-autocomplete-street-number[data-autocomplete="' + dataAutocomplete + '"]'),
		elementPostcodeHiddenField = document.querySelector('.js-autocomplete-postal-code[data-autocomplete="' + dataAutocomplete + '"]'),
		elementCityHiddenField = document.querySelector('.js-autocomplete-city[data-autocomplete="' + dataAutocomplete + '"]');

	// reset inputs to prevent value transfer that validates
	elementStreetHiddenField.value = '';
	elementStreetNumberHiddenField.value = '';
	elementPostcodeHiddenField.value = '';
	elementCityHiddenField.value = '';

	if (place && place.hasOwnProperty('address_components')) {
		for (const component of place.address_components) {
			const componentType = component.types[0];
			switch (componentType) {
				case "route": {
					elementStreetHiddenField.value = component.long_name;
					break;
				}
				case "street_number": {
					elementStreetNumberHiddenField.value = component.long_name;
					break;
				}
				case "postal_code": {
					elementPostcodeHiddenField.value = component.long_name;
					break;
				}
				case "locality": {
					elementCityHiddenField.value = component.long_name;
					break;
				}
			}
		}

		addressAutocompleteInputField.value = place.formatted_address;
	}

	addressAutocompleteFieldValidation(addressAutocompleteInputField);

}

export function validateAddressWithGeocoder(addressAutocompleteInputField) {

	let addressAutocompleteFieldValue = '';

	if (addressAutocompleteInputField) {
		addressAutocompleteFieldValue = addressAutocompleteInputField.value;

		if (!addressAutocompleteFieldValue) {
			setHiddenFieldValues('', addressAutocompleteInputField);
			return;
		}

		if (addressAutocompleteFieldValue) {
			const geocoder = new google.maps.Geocoder();

			geocoder.geocode({address: addressAutocompleteFieldValue})
				.then(response => {

					if (response.results.length > 0) {
						// Response is a valid address
						setHiddenFieldValues(response.results[0], addressAutocompleteInputField);
					} else {
						// Response is a invalid address
						setHiddenFieldValues('', addressAutocompleteInputField);
					}
				}).catch(error => {
				// Request is invalid or returned a zero result
				setHiddenFieldValues('', addressAutocompleteInputField);
			});
		}

	}

}
